import { FaLink } from "react-icons/fa";

export default function StorageDevMenuItem(props) {
    function visitStorage() {
        if (props.isFile) {
            window.open(
                `https://console.cloud.google.com/storage/browser/_details/corvus-backend.appspot.com/${props.path}`,
            );
        } else {
            window.open(
                `https://console.cloud.google.com/storage/browser/corvus-backend.appspot.com/${props.path}`,
            );
        }
    }

    return (
        <props.as onClick={visitStorage}>
            <FaLink
                className="me-2 text-primary"
                style={{ marginTop: "-2px" }}
            />
            Storage
        </props.as>
    );
}
